const textNavigationKeys = new Set([
  'ArrowLeft',
  'ArrowRight',
  'Tab',
  'Home',
  'End',
])
const BACKSPACE_KEY = 'Backspace'
const nonAdditiveClipBoardActionKeys = ['c', 'x']

export const isNonAdditiveValidKeyCombo = (ctrlKey, key) =>
  key === BACKSPACE_KEY ||
  textNavigationKeys.has(key) ||
  (ctrlKey && nonAdditiveClipBoardActionKeys.includes(key))
export const isHexadecimalChar = (key) => key.match(/^[\da-fA-F]$/)

export const isEightHexadecimalChars = /^[\da-fA-F]{8}$/g

export const parseHexadecimal = (id) => parseInt(id, 16)

export const ESCAPE_KEY = 27
